import { sliderHorizontal } from 'd3-simple-slider';
import { select } from 'd3-selection';
import { format } from 'd3-format';

export function yearSlider(el, binding) {
  const { handleChange, options, width } = binding.value;
  const min = options[0];
  const max = options[options.length - 1];

  const slider = sliderHorizontal()
    .min(min)
    .max(max)
    .step(1)
    .width(width - 36)
    .ticks(max - min)
    .tickFormat(format(''))
    .default(options[options.length - 1])
    .on('onchange', handleChange);

  const svg = select(el);
  svg.selectAll('*').remove();
  svg.append('g').attr('transform', 'translate(18, 20)').call(slider);
}
